import React from 'react';
import styled from 'styled-components/macro';
import { Helmet } from 'react-helmet';

import Content from 'components/styled/Content/Content';
import ScrollTopOnMount from 'components/utility/ScrollTopOnMount/ScrollTopOnMount';
import NotificationSettingsModal from '../../components/notifications/Settings';
import BackToTop from 'components/BackToTop/BackToTop';
import Footer from 'components/Footer/Footer';
import PlaylistActivityHeader from 'components/PlaylistActivity/PlaylistActivityHeader/PlaylistActivityHeader';
import FAQActivityTrackerBlock from 'components/FAQActivityTracker/FAQActivityTrackerBlock/FAQActivityTrackerBlock';

const Main = styled.div.attrs({
  role: 'main',
})`
  position: relative;
  z-index: 1;
  flex: auto;
  display: flex;
  flex-flow: column nowrap;
  background-color: ${({ theme }): string => theme.LightGrey};
`;

const FAQActivityTracker: React.FC = () => (
  <>
    <ScrollTopOnMount />
    <Helmet defer={false} title="Activity Tracker" />

    <NotificationSettingsModal />

    <PlaylistActivityHeader
      smallTitle="popular playlists"
      title="Activity Tracker"
    />

    <Main>
      <Content>
        {/* Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components. */}
        <div>
          <FAQActivityTrackerBlock />
        </div>
      </Content>
    </Main>
    <BackToTop />
    <Footer />
  </>
);

export default FAQActivityTracker;
